if (!customElements.get('sticky-add-to-cart')) {
  class StickyAddToCart extends HTMLElement {
    constructor() {
      super();
      this.originalButton = null;
      this.handleScroll = this.handleScroll.bind(this);
    }

    connectedCallback() {
      // Wait for DOM to be ready
      setTimeout(() => this.init(), 500);
    }

    init() {
      // Find the original add-to-cart button on the page
      this.originalButton =
        document.querySelector('buy-buttons') ||
        document.querySelector('.product-form') ||
        document.querySelector('form[action="/cart/add"]') ||
        document.querySelector('[name="add"]')?.closest('form');

      if (!this.originalButton) {
        console.warn('Sticky Add to Cart: Original button not found.');
        return;
      }

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      // Initial check
      this.handleScroll();

      // Also listen for variant changes to update the sticky form's variant ID
      this.setupVariantSync();
    }

    handleScroll() {
      if (!this.originalButton) return;

      const rect = this.originalButton.getBoundingClientRect();

      if (rect.bottom < window.innerHeight) {
        this.classList.add('is-visible');
      } else {
        this.classList.remove('is-visible');
      }
    }

    setupVariantSync() {
      // Listen for variant change events dispatched by the theme
      document.addEventListener('variant:change', (event) => {
        const variantId = event.detail?.variant?.id;
        if (variantId) {
          const input = this.querySelector('input[name="id"]');
          if (input) {
            input.value = variantId;
          }
        }
      });

      // Also observe the original form's hidden variant input for changes
      const originalVariantInput = this.originalButton.querySelector('input[name="id"]');
      if (originalVariantInput) {
        this.mutationObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
              const input = this.querySelector('input[name="id"]');
              if (input) {
                input.value = originalVariantInput.value;
              }
            }
          });
        });
        this.mutationObserver.observe(originalVariantInput, { attributes: true });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
